export default __webpack_public_path__ + "static/media/Be_A_Part-03.486dec7a.svg";